<template>
  <VerifyBankPlaid
    v-if="bankingProvider === 'plaid'"
    :docs-stand-alone="docsStandAlone"
    :event-prefix="eventPrefix"
    @switch-to-flinks="handleSwitchToFlinks"
  />
  <VerifyBankFlinks
    v-else
    :docs-stand-alone="docsStandAlone"
    :event-prefix="eventPrefix"
    :instituition-id="instituitionId"
  />
</template>

<script>

import VerifyBankFlinks from '@/components/steps/common/VerifyBankFlinks.vue'
import VerifyBankPlaid from '@/components/steps/common/VerifyBankPlaid.vue'
import DataLayer from '@/utilities/data-layer'

export default {
  // Name
  name: 'VerifyBank',

  components: {
    VerifyBankPlaid,
    VerifyBankFlinks
  },

  props: {
    eventPrefix: {
      type: String,
      default: 'ploan'
    },

    docsStandAlone: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      instituitionId: undefined
    }
  },

  computed: {
    // Computed
    bankingProvider () {
      return this.$store.state.application.bankingProvider
    }
  },

  // Created
  created () {
    if (this.resetDocsOnLoad) {
      this.$store.dispatch('setId', false)
      this.$store.dispatch('setIdFile', undefined)
    }
  },

  methods: {
    handleSwitchToFlinks (instituitionId) {
      if (!process.env.VUE_APP_BANK_PROVIDER_SWITCH_ENABLED && !process.env.VUE_APP_DISABLE_FI_SELECTOR) return
      this.instituitionId = instituitionId
      this.$store.dispatch('setFlinksInstitutionId', instituitionId)
      this.$store.dispatch('setBankingProvider', 'flinks')
      DataLayer.pushObject({
        event: `spring_${this.eventPrefix}_plaid_switch_to_flinks`,
        instituitionId: this.instituitionId
      })
    }
  }
}
</script>

<style lang="scss">
</style>
